// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconCocktail = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path
      fillRule="evenodd"
      d="M4.122 3.086L3.375 4.75l7.686 8.63V19H9v2h6v-2h-1.94v-5.619l7.687-8.63L20 3.086zm13.648 2l-5.71 6.41-5.709-6.41z"
    />
  );
export default SvgIconCocktail;
